import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SmartbarComponent } from './smartbar.component';

@NgModule({
  declarations: [SmartbarComponent],
  imports: [CommonModule],
  exports: [SmartbarComponent]
})
export class SmartbarModule {}

export * from './smartbar.component';
